// test1290
(1290 && 0);
